export default __webpack_public_path__ + "static/media/rectangle.40b218ba.svg";